import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";

import ImageEditorPage from "../../Detalj/ImageEditorPage";

import {
    getMiljogebyrBildeBase64,
    postMiljogebyrerBilder,
} from "../../../../actions/miljogebyrerActions";
import {
    getMiljokontrollBildeBase64,
    postMiljokontrollObservasjonBilde,
} from "../../../../actions/miljokontrollerActions";

export default function MiljogebyrImageEditorPageContainer() {
  const {
    id: miljogebyrId,
    miljokontrollId,
    observasjonId,
    bildeId,
  } = useParams();
  const dispatch = useDispatch();

  const getBilde = useCallback(
    miljokontrollId && observasjonId
      ? () => dispatch(getMiljokontrollBildeBase64(miljokontrollId, observasjonId, bildeId))
      : () => dispatch(getMiljogebyrBildeBase64(miljogebyrId, bildeId)),
    [dispatch, miljogebyrId, miljokontrollId, observasjonId, bildeId] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const handlePostBilder = useCallback(
    miljokontrollId && observasjonId
      ? (_unused, file) => dispatch(postMiljokontrollObservasjonBilde(miljokontrollId, observasjonId, file, bildeId))
      : (_unused, file) => dispatch(postMiljogebyrerBilder(miljogebyrId, file, true, true)),
    [dispatch, miljogebyrId, miljokontrollId, observasjonId, bildeId] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return (
    <ImageEditorPage
      getBilde={getBilde}
      postIleggelserBilder={handlePostBilder}
    />
  );
}
